/**
 * Blue Zone Pre-order Modal 2 - Bootstrap Script
 * Global trigger listener and modal loader
 * Based on original preorder bootstrap patterns for consistency
 */

(function() {
  'use strict';
  
  let modalLoaded = false;
  let modalScriptsLoaded = false;
  
  /**
   * Check if current page should show pre-order modal
   * @returns {boolean} True if page contains /pre-order in path
   */
  function shouldShowPreorderModal2() {
    return window.location.pathname.includes('/pre-order');
  }
  
  /**
   * Load the main modal bundle and dependencies
   */
  function loadPreorderModal2() {
    if (modalLoaded) {
      window.PreorderModal2.open().catch(error => {
        console.warn('Failed to open Pre-order modal 2:', error);
      });
      return;
    }
    
    if (modalScriptsLoaded) return;
    modalScriptsLoaded = true;
    
    // Load CSS first
    const cssUrl = window.PreorderAssetUrls2.css;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
    
    // Load scripts sequentially to ensure proper dependency order
    const scriptsToLoad = window.PreorderAssetUrls2.scripts;
    
    let currentScriptIndex = 0;
    
    function loadNextScript() {
      if (currentScriptIndex >= scriptsToLoad.length) {
        // All scripts loaded, initialize modal
        modalLoaded = true;
        window.PreorderModal2.init();
        // Ensure modal becomes visible when JS is ready
        const root = document.getElementById('preorder-2-modal');
        if (root) root.style.display = '';
        window.PreorderModal2.open().catch(error => {
          console.warn('Failed to open Pre-order modal 2:', error);
        });
        return;
      }
      
      const script = document.createElement('script');
      script.src = scriptsToLoad[currentScriptIndex];
      script.onload = () => {
        currentScriptIndex++;
        loadNextScript();
      };
      script.onerror = () => {
        // Failed to load Pre-order script - silent fail for production
        currentScriptIndex++;
        loadNextScript();
      };
      document.head.appendChild(script);
    }
    
    loadNextScript();
  }
  
  /**
   * Handle trigger clicks
   */
  function handleTriggerClick(e) {
    const target = e.target.closest('a[href="#pre-order-2"]');
    if (!target) return;
    
    e.preventDefault();
    
    // Check if page should show pre-order modal
    if (!shouldShowPreorderModal2()) {
      console.warn('Pre-order modal 2 not available on this page');
      return;
    }
    
    // Track analytics for trigger source
    const source = target.textContent.trim() || target.getAttribute('aria-label') || 'unknown_trigger';
    
    // Apply discount code to URL if not already present
    if (!window.location.search.includes('discount=')) {
      const newUrl = window.location.pathname + '?discount=PRE-ORDER25' + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
    
    // Load and open modal
    loadPreorderModal2();
    
    // Track analytics after modal opens
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'pre-order-2_modal_opened', {
          source: source,
          page: window.location.href
        });
      }
    }, 100);
  }
  
  /**
   * Setup global event listeners
   */
  function setupEventListeners() {
    // Listen for trigger clicks
    document.addEventListener('click', handleTriggerClick, true);
    
    // Listen for hash changes (in case someone navigates to #pre-order-2)
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#pre-order-2' && shouldShowPreorderModal2()) {
        loadPreorderModal2();
      }
    });
    
    // Check if page was loaded with hash
    if (window.location.hash === '#pre-order-2' && shouldShowPreorderModal2()) {
      loadPreorderModal2();
    }
  }
  
  /**
   * Initialize bootstrap when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEventListeners);
    } else {
      setupEventListeners();
    }
  }
  
  // Initialize
  init();
  
})();
